import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as apiUtil from '../../util/apiUtil';
import NaverAppClauseV1 from './naver/NaverAppClauseV1';

const CLAUSE_MAP: { [version: string]: React.FC<{ companyName: string }> } = {
  '1': NaverAppClauseV1,
};

export default function NaverAppClausePage() {
  const { appUid, version } = useParams<{ appUid: string; version: string }>();
  const [companyName, setCompanyName] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!appUid || !version) {
      setError(true);
      setLoading(false);
      return;
    }

    if (!CLAUSE_MAP[version]) {
      setError(true);
      setLoading(false);
      return;
    }

    apiUtil.asyncRequest({
      url: `/api/bizchat/naver-app/public/${appUid}/clause-info`,
      method: apiUtil.requestMethod.GET,
      success: (result: any) => {
        setCompanyName(result.companyName);
        setLoading(false);
      },
      fail: () => {
        setError(true);
        setLoading(false);
      },
    });
  }, [appUid, version]);

  if (loading) {
    return (
      <div style={styles.centered}>
        <div style={styles.spinner} />
      </div>
    );
  }

  if (error || !companyName || !version || !CLAUSE_MAP[version]) {
    return (
      <div style={styles.centered}>
        <p style={styles.errorText}>유효하지 않은 약관 링크입니다.</p>
      </div>
    );
  }

  const ClauseComponent = CLAUSE_MAP[version];
  return <ClauseComponent companyName={companyName} />;
}

const styles: { [key: string]: React.CSSProperties } = {
  centered: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  spinner: {
    width: '32px',
    height: '32px',
    border: '3px solid #e0e0e0',
    borderTopColor: '#03A94D',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
  errorText: {
    color: '#888',
    fontSize: '15px',
  },
};
